<app-add-all-stock-form type="edit" [stockId]="stockId()" />
